import { DieTypes } from "@/constants";
import { customSetIdPrefix } from "@/constants/diceConfig";
import type { CustomUrlMap, DieType } from "@/types";
import { create } from "zustand";
import { persist } from "zustand/middleware";

type SelectedSet = {
  fullName: string;
  id?: string;
};
type DicePreviewerState = {
  selectedSet?: SelectedSet;
  setSelectedSet: (selectedSet: SelectedSet | undefined) => void;
  dieType: DieType;
  setDieType: (dieType: DieType) => void;
  customUrlMap?: CustomUrlMap;
  setCustomUrlMap: (customUrlMap: CustomUrlMap | undefined) => void;
  customSetOverrideId: string;
  setCustomSetOverrideId: (customSetOverrideId: string) => void;
};

export const useDicePreviewerStore = create<DicePreviewerState>()(
  persist(
    (set) => ({
      setSelectedSet: (selectedSet) => set(() => ({ selectedSet })),
      dieType: DieTypes.d20,
      setDieType: (dieType) => set(() => ({ dieType })),
      setCustomUrlMap: (customUrlMap) => set(() => ({ customUrlMap })),
      customSetOverrideId: "",
      setCustomSetOverrideId: (customSetOverrideId) =>
        set(() => ({ customSetOverrideId })),
    }),
    {
      name: "dicePreviewerState",
      partialize: (state) => ({
        selectedSet:
          // Avoid persisting custom sets, since files are temporary
          state.selectedSet?.id?.startsWith(customSetIdPrefix)
            ? { fullName: "" }
            : state.selectedSet,
        dieType: state.dieType,
      }),
    },
  ),
);
